async function submitDraftOrder(btn, tags) {
  const workerUrl   = btn.dataset.workerUrl;
  const customerEmail = btn.dataset.customerEmail;
  const customerId  = btn.dataset.customerId;

  const originalHTML = btn.innerHTML;
  btn.disabled = true;
  // Loading state: spinner SVG + text
  btn.innerHTML = '<svg class="aigo-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Placing order\u2026';

  try {
    const cachedCart = window.FoxTheme && window.FoxTheme.Cart && window.FoxTheme.Cart.getState();
    const cart = cachedCart || await (await fetch('/cart.js')).json();

    // Full address from checkout form (desktop or mobile, whichever is active)
    const address = (window.FoxTheme && window.FoxTheme.Cart)
      ? window.FoxTheme.Cart.getAddress()
      : (window.AigoShipping && window.AigoShipping.getAddress ? window.AigoShipping.getAddress() : {});

    if (!address.address1 || !address.city || !address.province || !address.zip) {
      alert('Please fill in your delivery address (street, city, state, ZIP) before placing an order.');
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      return;
    }

    // Selected shipping rate
    const shippingRate = (window.FoxTheme && window.FoxTheme.Cart)
      ? window.FoxTheme.Cart.getSelectedRate()
      : (window.AigoShipping && window.AigoShipping.getSelectedRate ? window.AigoShipping.getSelectedRate() : null);
    const freeShipping = document.getElementById('aigo-ship-card')
      && document.getElementById('aigo-ship-card').dataset.freeShipping === 'true';

    if (!shippingRate && !freeShipping) {
      alert('Please select a shipping method before continuing.');
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      return;
    }

    // Order note — read from whichever textarea is active
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const noteEl   = document.getElementById(isMobile ? 'mco-note' : 'co-note');
    const note     = noteEl ? noteEl.value.trim() : '';

    // Promo code
    const promoEl  = document.getElementById(isMobile ? 'mco-promo' : 'co-promo');
    const promoCode = promoEl ? promoEl.value.trim() : '';

    // Promo discount amount (set by the promo code IIFE when a code is applied)
    const promoAmountCents = (window.FoxTheme && window.FoxTheme.Cart)
      ? window.FoxTheme.Cart.getPromoDiscount()
      : (window._aigoPromoCents || 0);

    const response = await fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.items,
        email: customerEmail,
        customerId,
        address,
        tags,
        ...(note          && { note }),
        ...(shippingRate  && { shippingLine: { title: shippingRate.title, price: shippingRate.price } }),
        ...(promoCode          && { promoCode }),
        ...(promoAmountCents > 0        && { promoAmountCents }),
        ...(freeShipping                && { freeShipping: true }),
      }),
    });

    if (response.ok) {
      const result = await response.json();
      const draftOrder = result.draft_order || {};

      // Button → success state
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Order placed';

      // Build toast payload from draft order response
      const items = draftOrder.line_items || [];
      const names = items.map(function(i) { return i.title; });
      const display = names.slice(0, 2);
      const extra = names.length - 2;
      const itemNames = display.join(', ') + (extra > 0 ? ' + ' + extra + ' more' : '');

      // Publish event — aigo-toast.js subscribes and shows the toast
      if (window.FoxTheme && window.FoxTheme.pubsub) {
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.draftOrderCreated, {
          email: draftOrder.email || customerEmail,
          itemCount: parseInt(btn.dataset.thresholdCount, 10) || items.reduce(function(sum, i) { return sum + (i.quantity || 1); }, 0),
          itemNames: itemNames,
          estimatedTotal: draftOrder.total_price,
          currency: draftOrder.currency || 'USD',
          shippingTitle: freeShipping ? 'Free Delivery' : ((draftOrder.shipping_line && draftOrder.shipping_line.title) || ''),
          discountTotal: promoAmountCents > 0 ? (promoAmountCents / 100).toFixed(2) : null,
        });
      }

      // Clear cart silently — do NOT publish cartUpdate, do NOT re-render page
      sessionStorage.removeItem('aigo_selected_addr');
      // Clear discount code first (items clear doesn't remove it), then items
      if (window.FoxTheme && window.FoxTheme.Cart) {
        await window.FoxTheme.Cart.update({ discount: '' });
        await window.FoxTheme.Cart.clear();
      } else {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });
        await fetch('/cart/clear.js', { method: 'POST' });
      }
      // Redirect is handled by aigo-toast.js after toast dismisses
    } else {
      throw new Error('API returned an error');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Sorry, an error occurred. Please try again later.');
    btn.innerHTML = originalHTML;
    btn.disabled = false;
  }
}

document.addEventListener('click', async function (e) {
  // Desktop buttons
  const quoteBtn = e.target.closest('#create-quo');
  if (quoteBtn) { /* hidden — no-op until quote workflow is defined */ return; }

  const placeOrderBtn = e.target.closest('#place-order');
  if (placeOrderBtn) {
    e.preventDefault();
    if (!placeOrderBtn.classList.contains('btn--locked')) {
      await submitDraftOrder(placeOrderBtn, 'draft-order');
    }
    return;
  }

  // Mobile buttons
  const mQuoteBtn = e.target.closest('#mco-create-quo');
  if (mQuoteBtn) { /* hidden — no-op until quote workflow is defined */ return; }

  const mPlaceBtn = e.target.closest('#mco-place-order');
  if (mPlaceBtn) {
    e.preventDefault();
    if (!mPlaceBtn.classList.contains('m-btn--locked')) {
      await submitDraftOrder(mPlaceBtn, 'draft-order');
    }
  }
});
